<template>
    <div id="home-page">
        <section class="hero is-default animated">
            <div class="hero-body">
                <app-swipper></app-swipper>
            </div>
        </section>

        <app-action-call-general  v-if="items.quote" :quote="items.quote"></app-action-call-general>

        <section class="section mtb-40">
            <div class="columns is-multiline is-mobile">
                <app-card v-for="item in items.albums" :key="item.id" :item="item" :link="linkAlbums" :len="items.albums.length"></app-card>
            </div>
        </section>


        <section class="section p0">
            <div v-if="items.photos" class="bg-light1 mtb-80">
                <app-sb :photos="items.photos"></app-sb>
            </div>

        </section>

        <app-action-call-footer  v-if="items.testimonials && items.post" :testimonials="items.testimonials" :post="items.post"></app-action-call-footer>
    </div>
</template>

<script>

import { ApiHome, PhotoUrl } from '../.env';
import { mapGetters, mapActions } from 'vuex';
import AlbumCard from '../components/elements/card/AlbumCard.vue';
import Swipper from '../components/elements/swipper/Swipper';
import Silentbox from '../components/elements/silentbox/Silentbox.vue';
import CaGeneral from '../components/complex/CaGeneral';
import CaFooter from '../components/complex/CaFooter';

export default {
    components: {
        'app-card': AlbumCard,
        'app-swipper': Swipper,
        'app-sb': Silentbox,
        'app-action-call-general': CaGeneral,
        'app-action-call-footer': CaFooter,
    },

    data() {
        // console.log('route id: ', this.$route.params.id);
        return {
            endpoint: ApiHome + 'main',
            linkAlbums: '/albums/',
            linkPhotos: '/photos/',
            defaultUrl: PhotoUrl + '300/logo.png'
        }
    },

    computed: {
        ...mapGetters([
            'items',
            'error',
            'loading'
        ]),

        imageUrl() {
            if(this.items.photoQuote) {
                return '<img src="' + PhotoUrl + this.items.photoQuote.album_id + '/300/' + this.items.photoQuote.image + '" />';
            }
            return ;
        },
        // if you need to setup sth extra
        /*getErrors() {
            if(this.error === null) {
                return ' NO errors ', this.error;
            }
            return this.error;
        }*/
    },

    methods: {
        ...mapActions([
            'clearError',
            'setError',
            'clearNotification',
        ]),

        fetchHome() {
            this.$store.dispatch('fetchItems', this.endpoint);
        },
    },
    created() {
        // this.$store.dispatch('clearNotification');
        // this.$store.dispatch('clearError');
        this.fetchHome();
        // console.log('created home');
    }
}

</script>
<style lang="scss" scoped>
.is-title {
    text-transform: capitalize;
}

#home-page .hero {
    margin-top: 55px;
}


</style>



// WEBPACK FOOTER //
// src/views/Home.vue